import { createContext, useContext, useState } from 'react';

const StockPromoContext = createContext();

const initialState = {
  selectedTab: 'stock',
  isOpenModalDetailWarehouse: false,
  detailWarehouseData: null,
  isOpenModalDetailPromo: false,
  detailPromoData: null,
};

const initialFilterState = {
  page: 1,
  limit: 10,
  search: '',
  brand: null,
  statusStock: null,
  promoStatus: null,
  shop: null,
};

const StockPromoProvider = ({ children }) => {
  const [state, setState] = useState(initialState);
  const [filterState, setFilterState] = useState(initialFilterState);

  const updateState = (payload) => setState((prev) => ({ ...prev, ...payload }));
  const updateFilterState = (payload) => setFilterState((prev) => ({ ...prev, ...payload }));

  return <StockPromoContext.Provider value={{ updateState, ...state, updateFilterState, filterState }}>{children}</StockPromoContext.Provider>;
};

export const useStockPromoState = () => {
  return useContext(StockPromoContext);
};

export default StockPromoProvider;
